export const name = "RTRIM";
export const summary = `Identical to the \`TRIM\` function, but only removes trailing characters.`;
export const reference = `
## RTRIM

Identical to the \`TRIM\` function, but only removes trailing characters.

\`\`\`
RTRIM(value1[, value2])
\`\`\`

### Description

Identical to TRIM, but only removes trailing characters.


### Return type

\`STRING\` or \`BYTES\`


### Examples



\`\`\`
SELECT RTRIM(' ***apple***', '*') AS example

/*-----------*
 | example |
 +-----------+
 | ***apple |
 *-----------*/
\`\`\`



\`\`\`
SELECT RTRIM('applexxz', 'xyz') AS example

/*---------*
 | example |
 +---------+
 | apple |
 *---------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/string_functions
`;
